<template>
  <div
      id="app"
      :class="uiClass()">
    <transition
        name="fade"
        mode="out-in">
      <router-view />
    </transition>
    <vue-progress-bar />
    <device-missing
        v-if="missingDeviceData"
        ref="missingDevice"
        :profile="missingDeviceData"
        @close-missing="closeMissing" />
  </div>
</template>

<script>
import { EventBus } from "./eventBus";
import permission from "@/mixins/permission";
import { createNamespacedHelpers as h } from "vuex";
import DeviceMissing from "./containers/Customer/Devices/DeviceMissing";
const { mapActions: authActions, mapGetters: authGetters } = h("auth");

import interceptorSetup from "./helpers/interceptors";
interceptorSetup();

export default {
  name: "App",
  components: {
    DeviceMissing,
  },
  mixins: [permission],
  data() {
    return {
      missingDeviceData: null,
    };
  },
  computed: {
    ...authGetters(["user"]),
  },
  created() {
    this.checkLoggedIn();
    let _refs = this.$refs;
    EventBus.$on("device-profile-only", (data) => {
      this.missingDeviceData = data;
      this.$nextTick(() => {
        _refs.missingDevice.openModal();
      });
    });

    EventBus.$on("action-no-authorized", (data) => {
      this.$nextTick(() => {
        this.$message.error(
          "RingTeam users are not allowed to perform this action"
        );
      });
    });
  },
  methods: {
    closeMissing() {
      this.missingDeviceData = null;
    },
    checkLoggedIn() {
      let token = this.$route.params.token;
      if (!this.user.id && !token && this.$route.name !== "Login")
        this.$router.push({ name: "Login" });
    },
    uiClass() {
      let classes = "new-ui";

      if (this.hasPermission("NewUI", "leftNav")) {
        classes += " new-ui__left-nav";
      }

      return classes.trim();
    },
  },
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
  margin: 0;
}

#app {
  margin: 0px;
  height: 100%;
  background: #fafbfc;
}

.fade-leave-active {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

a {
  cursor: pointer;
}
.pull-right {
  float: right;
}
.pull-left {
  float: left;
}

// Dialog css
.el-dialog__header {
  padding: 20px 40px;
}
</style>
